<script>
import { FormatPercentSalesKpi } from "../../utils";
export default {
  name: "HyperlinkKpiSatisfaccion",
  functional: true,
  props: {
    row: Object,
    column: String,
    mes: Number,
    openDetail: Function,
    getProductSelected: Function,
    getServiceTypeSelected: Function,
    getValoracionSelected: Function
  },
  render: function (createElement, context) {
    const val = Number(context.props.row[context.props.column]);
    let classs = "red";

    if (val <= 70) {
      classs = "red";
    } else if (val >= 99) {
      classs = "green";
    } else if (val >= 90 && val <= 99) {
      classs = "golden";
    }

    const MothValue = function (val) {
      // if (val > 0) {
      return FormatPercentSalesKpi(val);
      // } else {
      //   return "";
      // }
    };

    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#",
          class: classs
        },
        on: {
          click: () => {
            const {
              mes,
              row,
              openDetail,
              getProductSelected,
              getServiceTypeSelected,
              getValoracionSelected
            } = context.props;
            row.currentProductId = getProductSelected();
            row.currentServiceTypeId = getServiceTypeSelected();
            row.currentvaloracionId = getValoracionSelected();
            openDetail(mes, row);
          }
        }
      },
      MothValue(val)
    );
  }
};
</script>
<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
</style>
